import { Navigate, useLocation } from '@solidjs/router'
import { type JSX, Show } from 'solid-js'
import { authStore } from '../../stores/auth.store'

interface DeletionFreezeGateProps {
  children: JSX.Element
}

export const DELETE_ACCOUNT_PATH = '/app/candidate/settings/delete'

export function DeletionFreezeGate(props: DeletionFreezeGateProps) {
  const location = useLocation()
  const isFrozen = () => authStore.deletionScheduledFor !== null
  const onDeletePage = () => location.pathname === DELETE_ACCOUNT_PATH

  return (
    <Show when={!isFrozen() || onDeletePage()} fallback={<Navigate href={DELETE_ACCOUNT_PATH} />}>
      {props.children}
    </Show>
  )
}
